import { ADMIN_TYPE } from "@/enum";

export default [
  {
    path: "/airplanes",
    meta: {
      requiresAuth: true,
      permission: null,
      title: "Aeronaves",
      layout: "admin",
      module: "airplanes",
      icon: "mdi-airplane",
      notBreadCrumb: true,
      roles: [ADMIN_TYPE.RIDERY]
    },
    component: () =>
      import(
        /* webpackChunkName: "AirplanesLayout" */ "@/views/airplanes/AirplanesLayout.vue"
      ),
    children: [
      {
        path: "",
        name: "airplanes-list",
        meta: {
          requiresAuth: true,
          permission: null,
          layout: "admin",
          module: "airplanes",
          title: "Listado",
          adminLayoutNav: true,
          icon: "mdi-format-list-bulleted",
          notBreadCrumb: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "AirplanesList" */ "@/views/airplanes/AirplanesTable.vue"
          ),
      },
      {
        path: "amenities",
        name: "airplane-amenities",
        meta: {
          requiresAuth: true,
          permission: null,
          layout: "admin",
          title: "Amenidades",
          adminLayoutNav: true,
          icon: "mdi-format-list-bulleted",
          notBreadCrumb: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "AirplaneAmenities" */ "@/views/airplanes/AirplaneAmenities.vue"
          ),
      },
      {
        path: ":id",
        name: "airplane-details",
        meta: {
          requiresAuth: true,
          permission: null,
          layout: "admin",
          module: "airplanes",
          title: "Detalles",
          adminLayoutNav: false,
          icon: "mdi-format-list-bulleted",
          notBreadCrumb: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "AirplanesList" */ "@/views/airplanes/AirplaneDetails.vue"
          ),
      },
    ],
  },
];
